module.exports = __webpack_public_path__ + "img/運勢書banner文字.4049f01d.png";